var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"icon-heart",class:{favorited: _vm.isOn, 'not-favorited': _vm.isOn === false},on:{"click":_vm.toggleFavorite}},[_c('font-awesome-icon',{staticClass:"fa-2x",style:(_vm.iconStyle),attrs:{"icon":"heart"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }